import { createFileRoute } from "@tanstack/react-router"
import CollectionGreigeTab from "~/components/purchase-plan/CollectionGreigeTab"
import { WorkspacePage } from "~/components/design-system/pages"
import ViewConfiguration from "~/components/planning/ViewConfiguration"
import { SUPPLY_PLAN_COLLECTION_GREIGE_TABLE_ID } from "~/constants"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/collection/$collectionId/_layout/greige",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Fashion Supply Plan Detail - Greige")

  return (
    <WorkspacePage
      viewConfiguration={
        <ViewConfiguration tableId={SUPPLY_PLAN_COLLECTION_GREIGE_TABLE_ID} showFilters />
      }
    >
      <CollectionGreigeTab />
    </WorkspacePage>
  )
}
